module.exports = __webpack_public_path__ + "54242552b323c88f1242f16f82dedfb7.png";